export const stars = [
    { id: "star5", value: 5 },
    { id: "star4", value: 4 },
    { id: "star3", value: 3 },
    { id: "star2", value: 2 },
    { id: "star1", value: 1 }
  ];